/**
 * Returns the base URL depending on whether we are in a dev environment or not.
 */
export const baseUrl: string = import.meta.env.DEV
  ? 'http://localhost:7080'
  : import.meta.env.VITE_PUBLISHED_BASE_URL;

/**
 * Returns the API base URL.
 */
export const apiUrl: string = import.meta.env.DEV
  ? 'http://localhost:7081'
  : import.meta.env.VITE_PUBLISHED_API_URL;
